import { ref } from 'vue'

export function useSection() {
  // 已选择的选项
  const sectionList = ref<Recordable[]>([])

  // 选中项发生改变
  function selectionChange(data: any) {
    sectionList.value = JSON.parse(JSON.stringify(data))
  }
  return {
    sectionList,
    selectionChange
  }
}
